import { useState } from 'react';
import { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { NewsFiltersValue } from '../components/newsFilters/NewsFilters';



const defaultFilters: NewsFiltersValue = {
    search: '',
    priorities: [],
    startDate: undefined,
    dueDate: undefined,
};

export const useNewsFilters = () => {
    const [filters, setFilters] =
        useState<NewsFiltersValue>(defaultFilters);

    const resetFilters = () => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setFilters,
        resetFilters,
    };
};